/** Win-share card shown in chat when a player shares a top bet (skyx_new only). */
export const SKYX_NEW_CHAT_WIN_CARD_THEME = {
  cardBg: '#1F0A4D',
  cardBorder: 'rgba(123,60,255,0.3)',
  cardRadius: '16px',
  playerNameColor: '#ffffff',
  dateColor: 'rgba(201,184,245,0.7)',
  labelColor: 'rgba(201,184,245,0.7)',
  valueColor: '#ffffff',
  cashoutColor: '#B347FF',
  shieldGradient: 'linear-gradient(135deg, #6A00FF 0%, #B347FF 100%)',
  shieldButtonShadow:
    '0 1px 2px rgba(0,0,0,0.28), inset 0 1px 0 rgba(255,255,255,0.12), inset 0 -1px 0 rgba(0,0,0,0.12)',
  shieldButtonSizePx: 28,
  shieldIconSizePx: 28,
} as const;
